export default {"src":"/_next/static/media/laboratory-hospital-wheelchair.bd15b391.svg","height":343,"width":338,"blurWidth":0,"blurHeight":0};